import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileUp, Loader2, Download, Image as ImageIcon, FolderKanban } from "lucide-react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };
const DOCS = [
  { key: "interni", label: "PDF Lighting Concept — INTERNI", hint: "Copertina + moodboard interni. Sostituisce copertina e moodboard usati nei report.", preview: ["interni_cover", "interni_mood"] },
  { key: "esterni", label: "PDF Lighting Concept — ESTERNI", hint: "Copertina + moodboard esterni. Usato quando lo spazio è Esterni / Landscape.", preview: ["esterni_cover", "esterni_mood"] },
];

const DocCard = ({ doc, status, onUploaded }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const info = status?.docs?.[doc.key];
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await axios.post(`${API}/admin/templates/${doc.key}`, fd, cfg);
      toast.success(`${doc.label} aggiornato${r.data.mood ? ` — ${r.data.mood.slots} slot immagine nel moodboard` : ""}`);
      onUploaded();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Caricamento non riuscito");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid={`admin-doc-${doc.key}`} className="bg-white border border-ink/10 rounded-sm p-5 space-y-3">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-semibold text-ink text-sm">{doc.label}</p>
          <p className="text-xs text-inksoft mt-1">{doc.hint}</p>
          <p data-testid={`admin-doc-meta-${doc.key}`} className="text-[11px] text-inksoft mt-2">{info ? `${info.filename} · ${new Date(info.uploaded_at).toLocaleString("it-IT")}` : "Versione iniziale fornita dallo studio"}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <a data-testid={`admin-doc-download-${doc.key}`} href={`${API}/admin/templates/${doc.key}/file`} className="inline-flex items-center gap-1.5 border border-ink/20 hover:border-ink rounded-sm px-3 h-9 text-[10px] font-semibold uppercase tracking-[0.15em] text-ink"><Download className="w-3.5 h-3.5" />PDF</a>
          <input ref={ref} type="file" accept=".pdf" className="hidden" onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} data-testid={`admin-doc-input-${doc.key}`} />
          <button type="button" disabled={busy} data-testid={`admin-doc-upload-${doc.key}`} onClick={() => ref.current?.click()} className="inline-flex items-center gap-1.5 bg-ink text-cream hover:bg-[#C5A059] hover:text-ink disabled:opacity-60 rounded-sm px-3 h-9 text-[10px] font-semibold uppercase tracking-[0.15em]">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileUp className="w-3.5 h-3.5" />}Sostituisci
          </button>
        </div>
      </div>
      <div className="flex gap-2">
        {doc.preview.map((p) => (
          <img key={p} data-testid={`admin-doc-preview-${p}`} src={`${API}/admin/templates/preview/${p}.jpg?v=${status?.version || 0}`} alt={p} className="h-32 w-auto border border-ink/10 rounded-sm bg-cream object-contain" />
        ))}
      </div>
    </div>
  );
};

export const TemplatesPanel = () => {
  const [status, setStatus] = useState(null);
  const load = () => axios.get(`${API}/admin/templates`, cfg).then((r) => setStatus(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="admin-templates" className="space-y-4">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-inksoft">Documenti template del report</p>
          <p className="text-xs text-inksoft mt-1 flex items-center gap-1.5"><ImageIcon className="w-3.5 h-3.5" />Copertina e moodboard vengono rasterizzati e gli slot immagine del moodboard ricalcolati a ogni caricamento.</p>
        </div>
        <Link to="/progetti" data-testid="admin-projects-link" className="inline-flex items-center gap-1.5 border border-ink/20 hover:border-ink rounded-sm px-3 h-9 text-[10px] font-semibold uppercase tracking-[0.15em] text-ink"><FolderKanban className="w-3.5 h-3.5" />I Nostri Progetti</Link>
      </div>
      <div className="grid lg:grid-cols-1 gap-4">
        {DOCS.map((d) => <DocCard key={d.key} doc={d} status={status} onUploaded={load} />)}
      </div>
    </div>
  );
};
